<template>
  <div class="dialog-header">
    <div class="dialog-header-title">
      <h2 class="dialog-title">
        <img
          src="/img/icons/rs_icon.png"
          alt="Repair Icon"
          draggable="false"
          @mousedown.prevent.stop
          @dragstart.prevent.stop
          style="
            width: 1.5em;
            height: 1.5em;
            margin-bottom: 2px;
            margin-right: 15px;
          "
        />{{ title }}
      </h2>

      <b-icon
        icon="delete"
        class="action-icon"
        @mousedown.native.prevent.stop
        @touchend.native.prevent.stop="onClear"
        @dragstart.native.prevent.stop
        @click.native="onClear"
        title="Clear local history"
      />
      <button
        class="close-btn"
        @mousedown.prevent.stop
        @touchend.prevent.stop="onClose"
        @dragstart.prevent.stop
        @click="onClose"
      >
        ✖
      </button>
    </div>
    <p v-if="description" class="dialog-description" :title="description">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onClear() {
      this.$emit('clear');
    },
  },
};
</script>

<style scoped>
.action-icon {
  cursor: pointer;
  margin-right: 10px;
  font-size: 1.25em;
}

.action-icon:hover {
  color: #ff6b6b;
}

.dialog-header-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: inherit;
}

.dialog-description {
  font-size: 0.9em;
  font-weight: 300;
  margin-top: -5px;
  margin-bottom: -5px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  max-width: 75%;
  text-align: center;
  cursor: inherit;
}

.dialog-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #5b3ea5;
  color: white;
  padding: 10px;
  font-size: 1.2em;
  font-weight: bold;
  cursor: grab;
}

.dialog-header:active {
  cursor: grabbing;
}

.dialog-title {
  margin: 0 auto;
  text-align: center;
  flex: 1;
  cursor: inherit;
}

.dialog-title img {
  cursor: default;
  user-select: none;
}

.close-btn {
  background-color: transparent;
  border: none;
  color: white;
  font-size: 1.5em;
  cursor: pointer;
}

.close-btn:hover {
  color: #ff6b6b;
}
</style>
